import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { Moodies } from "@somethings-ui/core/assets";
import { Button } from "@somethings-ui/web";
import { TrainingCompletionShell } from "./training-completion-shell.tsx";

interface TrainingAllModulesCompleteProps {
  onBackToTraining: () => void;
}

export function TrainingAllModulesComplete({
  onBackToTraining,
}: TrainingAllModulesCompleteProps) {
  return (
    <TrainingCompletionShell
      bgClassName="bg-brand-blush"
      title="All modules complete"
      body="Your training is complete and ready for review. A lead mentor will look over your sessions and share feedback soon."
      decorations={
        <>
          <img
            src={Moodies.awkwardBlack}
            alt=""
            aria-hidden
            className="pointer-events-none absolute -right-40 -top-40 w-[620px] max-w-none -rotate-12 select-none"
          />
          <img
            src={Moodies.awkwardBlack}
            alt=""
            aria-hidden
            className="pointer-events-none absolute -bottom-60 -left-80 w-[800px] max-w-none -rotate-[34deg] select-none"
          />
        </>
      }
    >
      <Button
        variant="primary"
        fullWidth={false}
        leadingIcon={<ArrowLeftIcon className="size-4" />}
        onClick={onBackToTraining}
      >
        Back to Training Room
      </Button>
    </TrainingCompletionShell>
  );
}
